
import axios from "axios";
import { useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import "../workers/WorkerCategories.css"
import deleteIcon from "../../../assets/img/small-logos/delete _icon.svg";
import Swal from "sweetalert2";
import "../doorstepServices/DoorstepServices.css";
import { IWorkerRatings } from "src/helper/interfaces";
import Cookies from "js-cookie";
// import eye from "../../../assets/img/icons/eye-solid.svg"
// import moment from "moment";
import profileIcon from "../../../assets/img/icons/vecteezy_man-empty-avatar-vector-photo-placeholder-for-social_36594092.jpg"
import Paginator from "src/components/layout/Paginator";
// import jsPDF from "jspdf";
// import autoTable from 'jspdf-autotable';
// import ExportDocs from "src/components/layout/ExportDocs";
import StarRating from "src/components/layout/StarRating";
import ImageIcon from "../../../assets/img/landscape-placeholder-svgrepo-com.svg";
// import { Modal, Button } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
import { formatDiffrentDate } from "src/utils/normalFuntions";
import LoadingGif from "src/components/layout/Loader";

export const getAllReviews = async (
   token: string,
   pageNumber: number,
   pageSize: number,
   searchValue: string,
   startDate?: string,
   endDate?: string,
   customer_type?: string,
   customer_id?: string
) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/ratings`, {
      headers: {
         "x-access-token": token
      },
      params: {

         page: pageNumber,
         search_value: searchValue,
         pageSize,
         start_date: startDate,
         end_date: endDate,
         customer_type,
         customer_id
      }

   })
};

const deleteReviewById = async (token: string, id: string) => {
   return await axios.delete(`${AppConfig?.DEV_SERVER}/ratings/${id}`, {
      headers: {
         "x-access-token": token
      }
   })
}


const Reviews = () => {
   const dispatch = useAppDispatch();
   const loading = useAppSelector(state => state.loading.value);

   const [reviews, setReviews] = useState<IWorkerRatings[]>([]);
   // const [modalShow, setModalShow] = useState(false);
   const Token = Cookies.get('token');
   // const [selectedReview, setSelectedReview] = useState<IWorkerRatings | null>(null);
   const [searchVal, setSearchVal] = useState("");
   const [pageNo, setPageNo] = useState(1);
   const [pageSize, setPageSize] = useState(20);
   const [totalPages, setTotalPages] = useState(0);
   const [startDate, setStartDate] = useState<Date | undefined>(undefined);
   const [endDate, setEndDate] = useState<Date | undefined>(undefined);
   // const [hideAllFilters, setHideAllFilters] = useState(false);
   const startingDate = startDate ? startDate.toISOString() : undefined;
   const endingDate = endDate ? endDate.toISOString() : undefined;
   // const dispatch = useAppDispatch();
   // const [show, setShow] = useState(false);

   // const handleClose = () => setShow(false);
   // const handleShow = () => setShow(true);

   useEffect(() => {

      if (Token) {
         dispatch(startLoading());
         getAllReviews(Token, pageNo, pageSize, searchVal, startingDate, endingDate).then((res) => {
            // console.log(res?.data?.data?.data);
            if (res?.data?.status_code === 200) {
               // console.log(res?.data)
               setReviews(res?.data?.data?.result);
               setTotalPages(res?.data?.data?.totalPages)
            }
         })
            .catch((err: any) => {
               console.log(err)
            }).finally(() => {
               dispatch(stopLoading());
            })
      }
   }, [Token, pageNo, searchVal, pageSize, startingDate, endingDate])


   // const handleShow = (id: string) => {
   //    if (!id) return;
   //    const getSelectedDoc = reviews.find((review: IWorkerRatings) => review?._id === id);
   //    if (getSelectedDoc !== undefined) {
   //       setSelectedReview(getSelectedDoc);
   //    };
   //    // setHideAllFilters(true)
   //    // setIsBackClicked(false)
   //    setShow(true);
   // }


   const clearSearchValue = () => {
      setSearchVal("");  // Clear the search input
   };

   const handlePageSizeChange = (e: any) => {
      setPageSize(e?.target?.value)
   }

   const handleDeleteReview = async (id: string) => {
      if (!Token) return;
      // console.log(id)
      dispatch(startLoading());
      try {
         Swal.fire({
            title: 'Are you sure?',
            text: "You sure want to delete this review!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes Delete!'
         }).then(async (response) => {
            if (response.isConfirmed) {
               // console.log("lamao")
               await deleteReviewById(Token, id).then((res) => {
                  // console.log("res: ", res?.data)
                  if (res?.data?.status_code !== 200) {
                     setTimeout(() => {
                        Swal.fire({
                           position: "center",
                           icon: "error",
                           title: "Error..!",
                           text: `${res?.data?.msg}`,
                           showConfirmButton: false,
                           timer: 3000
                        })
                        dispatch(stopLoading());
                     }, 1000);
                  }
                  else if (res?.data?.status_code === 200) {
                     setTimeout(() => {

                        Swal.fire({
                           position: "center",
                           icon: "success",
                           title: "Successfull !!",
                           text: res?.data?.msg,
                           showConfirmButton: false,
                           timer: 2000
                        }).then(() => {

                           getAllReviews(Token as string, pageNo, pageSize, searchVal).then((res) => {
                              // console.log(res)
                              if (res?.data?.status_code === 200) {
                                 setReviews(res?.data?.data?.result);
                                 setTotalPages(res?.data?.data?.totalPages)
                              } else {
                                 Swal.fire({
                                    icon: "error",
                                    title: "Oops...",
                                    text: `${res?.data?.data?.msg}`,

                                 });
                              }
                           })
                        })

                        dispatch(stopLoading());
                     }, 600 * 2);
                  }
               })
            }
         });


         // console.log('Response data:', response.data);
      } catch (error: any) {
         console.error('Error making POST request:', error.response ? error.response.data : error.message);
      }
   }

   return (
      <MainLayout

         showAllFilters={false}
         searchValue={searchVal}
         clearValChange={clearSearchValue}
         onChange={(e) => setSearchVal(e.target.value)}
         startDate={startDate}
         endDate={endDate}
         startDateOnChange={e => setStartDate(e)}
         endDateOnChange={e => setEndDate(e)}

      >

         <div className="mt-3 mb-3">
            {
               loading ?
                  <div>
                     <LoadingGif />
                  </div>
                  : ""
            }
            <div className="card category-main me-2 p-md-4" >


               {/* <Modal show={show} onHide={handleClose} centered>
                  <Modal.Header closeButton>
                     <Modal.Title>Verify Review</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                     <form>
                        <div className="row">


                           <div className="form-group col-6">
                              <label htmlFor="exampleFormControlSelect1">Ratings</label>
                              <StarRating averageRating={selectedReview?.rating as number} className={"lol"} />

                           </div>
                           <div className="form-group d-flex flex-column gap-2 mb-2  col-6">
                              <label htmlFor="review">Review Type</label>
                              <input className="form-control" type="rating-type"
                                 value={selectedReview?.rating_type === "normal" ? "Worker Rating" : "Service Rating"} id="ratingType" readOnly />
                           </div>
                           <div className="form-group d-flex flex-column gap-2 mb-2  col-12">
                              <label htmlFor="review">Review</label>
                              <textarea className="form-control" id="review" placeholder="Bla Bla Bla.." value={selectedReview?.comment} />
                           </div>
                           {
                              selectedReview?.rating_type !== "normal" ?
                                 <>
                                    <strong className="mb-1">Order Details</strong>
                                    <div className="form-group d-flex flex-column gap-2 mb-2" >
                                       <label htmlFor="exampleFormControlSelect2">Order ID</label>
                                       <input className="form-control" type="service-title" value={selectedReview?.doorstep_order_id} readOnly />
                                    </div>
                                    <div className="form-group d-flex flex-column gap-2 mb-2" >
                                       <label htmlFor="exampleFormControlSelect2">Order Name</label>
                                       <input className="form-control" type="service-title" value={selectedReview?.service_title} readOnly />
                                    </div>
                                 </> : ''
                           }

                           <strong className="mb-1">User Details</strong>
                           <div className="form-group d-flex flex-column gap-2 mb-2 col-6">
                              <label htmlFor="exampleFormControlSelect2">Name</label>
                              <input className="form-control" type="service-title" value={selectedReview?.user_name} readOnly />
                           </div>
                           <div className="form-group d-flex flex-column gap-2 mb-2 col-6">
                              <label htmlFor="exampleFormControlSelect2">Phone</label>
                              <input className="form-control" type="service-title" value={selectedReview?.user_phone} readOnly />
                           </div>
                           <strong className="mb-1">Worker Details</strong>
                           <div className="form-group d-flex flex-column gap-2 mb-2 col-6">
                              <label htmlFor="exampleFormControlSelect2">Name</label>
                              <input className="form-control" type="service-title" value={selectedReview?.worker_name} readOnly />
                           </div>
                           <div className="form-group d-flex flex-column gap-2 mb-2 col-6">
                              <label htmlFor="exampleFormControlSelect2">Phone</label>
                              <input className="form-control" type="service-title" value={selectedReview?.worker_phone} readOnly />
                           </div>
                           <div className="form-group d-flex flex-column gap-2 mb-2 col-6">
                              <label htmlFor="exampleFormControlSelect2">Is Worker Verified</label>
                              <input className={` form-control ${selectedReview?.worker_verified ? "text-success" : "text-danger"} `} type="service-title" value={selectedReview?.worker_verified ? "Verified" : "Not Verified"} readOnly />
                           </div>
                           <div className="form-group d-flex flex-column gap-2 mb-2 col-6">
                              <label htmlFor="exampleFormControlSelect2">Review Status</label>
                              <input className="form-control" type="service-title" value={"Pending"} readOnly />
                           </div>
                        </div>
                     </form>


                  </Modal.Body>
                  <Modal.Footer>
                     <Button variant="secondary" onClick={handleClose}>
                        Close
                     </Button>
                     <Button variant="primary" onClick={handleClose}>
                        Approve Review
                     </Button>
                  </Modal.Footer>
               </Modal> */}

               <div >
                  {/* <div className="d-flex justify-content-end gap-3 mb-3"> */}

                  <div className="d-flex justify-content-end gap-3 mb-3 ">

                     <div className="d-flex gap-2">
                        <span className="d-flex align-items-center pagesize-text">
                           PageSize
                        </span>

                        <select
                           className="form-select"
                           style={{ backgroundPosition: "right 5px center", width: "60px" }}
                           aria-label="Default select example"
                           value={pageSize} // Bind the value to the state
                           onChange={handlePageSizeChange} // Handle the change
                        >
                           <option value={20}>20</option>
                           <option value={50}>50</option>
                           <option value={100}>100</option>
                           <option value={200}>200</option>
                        </select>
                     </div>
                     <div>
                        {/* <ExportDocs headers={headers} formattedData={formattedData} clickHandler={exportPDF} /> */}
                     </div>


                  </div>


                  {/* </div> */}

                  <div className="table-extra-responsive">
                     <table className="table table-striped card-body">
                        <thead>
                           <tr className="category-tr">
                              <th scope="col" className="text-start ps-4">Sr.No.</th>
                              <th scope="col" className="text-start ps-4">Reviews</th>
                              <th scope="col" className="text-start ps-4">User Details</th>
                              <th scope="col" className="text-start ps-4">Order Details</th>
                              <th scope="col" className="text-start ps-4">Service Id</th>
                              <th scope="col" className="text-start ps-4">Worker Details </th>
                              <th scope="col" className="text-start ps-4">Reviewed At</th>
                              <th scope="col" className="cat_btns">Action</th>
                           </tr>
                        </thead>
                        <tbody>

                           {reviews && reviews?.map((data, i) => {
                              const date = formatDiffrentDate(data?.createdAt)
                              const rowNumber = (pageNo - 1) * pageSize + (i + 1);
                              const dotData = data?.comment
                                 ?.slice(0, 70) + (data?.comment.length > 70 ? " ..." : "");
                              return (
                                 <tr key={data?._id}>

                                    <td className="text-start ps-4 pt-3">{rowNumber}</td>
                                    <td className="text-start ps-4 pt-3" width={'300px'}>
                                       <div>
                                          <span title={data?.comment} style={{ cursor: "pointer" }}>
                                             {dotData ?? "NA"}
                                          </span>
                                          <StarRating averageRating={data?.rating} />
                                       </div>
                                    </td>
                                    <td className="text-start ps-4 pt-3">
                                       <div className="d-flex gap-3">
                                          {
                                             data?.user_pic ?
                                                <span className="d-flex align-items-center ">
                                                   <img src={data?.user_pic} alt="user-pic" className="rating-pic" />
                                                </span>
                                                :
                                                <span className="d-flex align-items-center ">
                                                   <img src={profileIcon} alt="profileIcon" className="rating-pic" />
                                                </span>
                                          }
                                          <div className="d-flex flex-column justify-content-center">
                                             <span className="text-bolder">{data?.user_name}</span>
                                             <span>{data?.user_phone}</span>
                                             <span className="text-success"> Verified </span>
                                          </div>
                                       </div>
                                    </td>

                                    <td className="text-start ps-4 pt-3" width={"200px"}>
                                       {
                                          data?.rating_type === "normal" ? <span >NA </span> :
                                             <div className="d-flex gap-3">
                                                {
                                                   data?.service_icon ?
                                                      <span className="d-flex align-items-center ">
                                                         <img src={data?.service_icon} alt="service-pic" className="rating-pic" />
                                                      </span>
                                                      :
                                                      <span className="d-flex align-items-center ">
                                                         <img src={ImageIcon} alt="profileIcon" className="rating-pic" />
                                                      </span>
                                                }
                                                <div className="d-flex flex-column justify-content-center">
                                                   <span className="text-bolder">{data?.service_title}</span>
                                                   <span>{data?.doorstep_order_id}</span>
                                                   <span className="text-success"> Service Rating </span>
                                                </div>
                                             </div>
                                       }

                                    </td>


                                    <td className="text-start ps-4 pt-3">
                                       {data?.doorstep_service_id || "NA"}
                                    </td>

                                    <td className="text-start ps-4 pt-3">
                                       <div className="d-flex gap-3">
                                          {
                                             data?.worker_pic ?
                                                <span className="d-flex align-items-center ">
                                                   <img src={data?.worker_pic} alt="worker-pic" className="rating-pic" />
                                                </span>
                                                :
                                                <span className="d-flex align-items-center ">
                                                   <img src={profileIcon} alt="profileIcon" className="rating-pic" />
                                                </span>
                                          }
                                          <div className="d-flex flex-column justify-content-center">
                                             <span className="text-bolder">{data?.worker_name}</span>
                                             <span>{data?.worker_phone}</span>
                                             <span className={`${data?.worker_verified ? "text-success" : "text-danger"} `}> {data?.worker_verified ? "Verified" : "Not Verified"} </span>
                                          </div>
                                       </div>
                                    </td>

                                    <td className="text-start ps-4 pt-3">
                                       <div className="d-flex flex-column ">
                                          <span>{date?.formattedDate} </span>
                                          <span>{date?.formattedHours} </span>
                                          <span>{date?.relativeTime} </span>

                                       </div>
                                    </td>

                                    <td className="align-content-center">
                                       <div className="d-flex justify-content-center gap-3">
                                          {/* <button className="btn btn-sm delete_btn" onClick={() => handleShow(data?._id)}>
                                             <img src={eye} alt="View" />
                                          </button> */}
                                          <button className="btn btn-sm edit_btn "
                                             onClick={() => handleDeleteReview(data?._id)}
                                             style={{ marginBottom: "1px" }}>
                                             <img src={deleteIcon} alt="deleteIcon" />
                                          </button>
                                       </div>
                                    </td>
                                 </tr>
                              );
                           })}


                        </tbody>
                     </table>
                     <Paginator
                        totalPages={totalPages}
                        pageNo={pageNo}
                        onPageChange={(e, no) => setPageNo(no)}
                        alignment="right"
                     />
                  </div>
               </div>




            </div>

         </div>

      </MainLayout>
   )

};


export default Reviews;